module.exports = __webpack_public_path__ + "static/media/as.e753c5e9.svg";